import * as types from '../constants/actionTypes';

// Fetch Delivery Addresses
export const fetchDeliveryAddressesRequest = (filters = {}) => ({
  type: types.FETCH_DELIVERY_ADDRESSES_REQUEST,
  payload: { filters }
});

export const fetchDeliveryAddressesSuccess = (addresses, totalCount) => ({
  type: types.FETCH_DELIVERY_ADDRESSES_SUCCESS,
  payload: { addresses, totalCount }
});

export const fetchDeliveryAddressesFailure = (error) => ({
  type: types.FETCH_DELIVERY_ADDRESSES_FAILURE,
  payload: { error }
});

// Create Delivery Address
export const createDeliveryAddressRequest = (addressData) => ({
  type: types.CREATE_DELIVERY_ADDRESS_REQUEST,
  payload: { addressData }
});

export const createDeliveryAddressSuccess = (address) => ({
  type: types.CREATE_DELIVERY_ADDRESS_SUCCESS,
  payload: { address }
});

export const createDeliveryAddressFailure = (error) => ({
  type: types.CREATE_DELIVERY_ADDRESS_FAILURE,
  payload: { error }
});

// Update Delivery Address
export const updateDeliveryAddressRequest = (id, addressData) => ({
  type: types.UPDATE_DELIVERY_ADDRESS_REQUEST,
  payload: { id, addressData }
});

export const updateDeliveryAddressSuccess = (address) => ({
  type: types.UPDATE_DELIVERY_ADDRESS_SUCCESS,
  payload: { address }
});

export const updateDeliveryAddressFailure = (error) => ({
  type: types.UPDATE_DELIVERY_ADDRESS_FAILURE,
  payload: { error }
});

export const setDeliveryAddressEditing = (address) => ({
  type: types.SET_DELIVERY_ADDRESS_EDITING,
  payload: { address }
});

// Clear Editing Address
export const clearDeliveryAddressEditing = () => ({
  type: types.CLEAR_DELIVERY_ADDRESS_EDITING
});